"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rechPrivacyPolicyVersion = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable max-len */
var material_1 = require("@mui/material");
var markdown_to_jsx_1 = __importDefault(require("markdown-to-jsx"));
var Main_1 = __importDefault(require("components/Layout/Main"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var Banner_1 = __importDefault(require("containers/App/Policies/styles/Banner"));
var Wrapper_1 = __importDefault(require("containersRechargly/Recharges/StripeClientAgreement/Wrapper"));
var PrivacyPolicy_md_1 = __importDefault(require("raw-loader!./PrivacyPolicy.md"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var TableStyles = (0, material_1.styled)('div')(function (_a) {
    var _b, _c;
    var theme = _a.theme;
    return ({
        table: {
            borderCollapse: 'collapse',
            width: '100%',
            margin: theme.spacing(1, 0),
            'th, td': {
                border: "1px solid ".concat(theme.palette.grey[300]),
                padding: theme.spacing(1),
            },
            th: {
                backgroundColor: (_b = theme.palette.neutral) === null || _b === void 0 ? void 0 : _b.light,
                borderColor: (_c = theme.palette.neutral) === null || _c === void 0 ? void 0 : _c.main,
            },
            ul: { margin: 0 },
        },
    });
});
// Please remember to change this number as you change the PrivacyPolicy content
exports.rechPrivacyPolicyVersion = 2;
var PrivacyPolicy = function () { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Privacy Policies", description: "Rechargly's Privacy Policies" }), (0, jsx_runtime_1.jsx)(Main_1.default, { children: (0, jsx_runtime_1.jsxs)(Wrapper_1.default, { children: [(0, jsx_runtime_1.jsx)(Banner_1.default, { children: (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1 }, { children: "Privacy Policy" })) }), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1 }, { children: ["Version number: ", exports.rechPrivacyPolicyVersion] })), (0, jsx_runtime_1.jsx)(TableStyles, { children: (0, jsx_runtime_1.jsx)(markdown_to_jsx_1.default, { children: PrivacyPolicy_md_1.default }) })] }) })] })); };
exports.default = PrivacyPolicy;
